import { Badge, ConditionalWrap } from '@libs/ui/ds'
import { useCommonsTranslation } from '@libs/utils/translations'
import React, { useMemo } from 'react'
import type { FC } from 'react'

import { isActiveDay } from './isActiveDay'

type Props = {
  date: string
}
export const DayLabel: FC<Props> = ({ date = null }) => {
  const { tDates } = useCommonsTranslation()
  // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
  const isSameDay = useMemo(() => isActiveDay(date), [date])

  return (
    <div className='w-fit text-center text-xs uppercase'>
      <ConditionalWrap
        condition={isSameDay}
        wrap={children => (
          <Badge
            variant='plain'
            label={children as any}
            color='semantic.blue'
            size='m'
          />
        )}
      >
        {tDates('dates.dayShortAndNumber', { date })}
      </ConditionalWrap>
    </div>
  )
}
